import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  ListSemantic_getInstance1hx6c2zatma42 as ListSemantic_getInstance,
  Semanticpmpmvt7fldq2 as Semantic,
  DisabledSemantic_getInstanceimdypc22j9b3 as DisabledSemantic_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  to2cs3ny02qtbcb as to,
  toList2vkrbx8s6dfjs as toList,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  assertViewerLens2aypbnpatof3k as assertViewerLens,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
} from '../../../../screens/common/ProjectView.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../../utils/JumpTo.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ChangeOrderDetails3bhfjfcpbf0qv as ChangeOrderDetails } from '../changeOrders/mobile/ChangeOrderDetails.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  ItemChangee3c665suy3yz as ItemChange,
  Incident3aojs8cp7629c as Incident,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
  Clientuccelyr89ch8 as Client,
  Contractor1wog4uk4l8u77 as Contractor,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  Creditv1m3yq08fl3i as Credit,
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  get_pending3bzoyvzwzq8kn as get_pending,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { Companion_instance3euo5q27joywz as Companion_instance_0 } from './LineItemCompletionForm.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Companion_instance2o1tmep3w0ant as Companion_instance_1 } from '../../activity/concerns/IncidentReportForm.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_incident3optryi02ng66 as get_incident } from '../../../../../../../../crowpay-shared/com/crowpay/IncidentMessageFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  plus20p0vtfmu0596 as plus,
  reversed22y3au42jl32b as reversed,
  plus310ted5e4i90h as plus_0,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CreditDetails2g0vi8qhuk0sb as CreditDetails } from '../../../../dialogs/BasicFlowForms.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { markAsReadUpdateOnRemovek70bbxx94h7h as markAsReadUpdateOnRemove } from '../../../../../extensions/HasReadBy.ext.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../nav/crowpay.mjs';
import { CreateOrEditNote2axvnom01lmg9 as CreateOrEditNote } from '../../../../dialogs/CreateOrEditNote.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  title1ahgushtajx2d as title,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  labeledSection16775qn7m7foh as labeledSection,
  label287uhiq3m9m4z as label2,
} from '../../../label2.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  lineItemAddChangeButton2cl2byr2d3toa as lineItemAddChangeButton,
  lineItemAddCreditButtonjm3cq3yje8r4 as lineItemAddCreditButton,
} from './components.mjs';
import {
  keyMoneyoelmapxkkp81 as keyMoney,
  keyString2ezqnhf3jck9c as keyString,
} from '../../../keyValue.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  renderPriceChangegxsbuhvani39 as renderPriceChange,
  priceWithChangedayxt0y21soj as priceWithChange,
} from '../../../priceChanges.mjs';
import {
  percentComplete22ixcedvdan2 as percentComplete,
  renderPercent3ullukkakwyrl as renderPercent,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
  filter31kgiqs90is7g as filter,
} from '../../../../../utils/utils.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  get_italic11nskfy97pz2f as get_italic,
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../../../theming/buttons.mjs';
import {
  newTasksAllowed2g7c6d9oaegnt as newTasksAllowed,
  newTasksAllowed26ihc5f4iqgon as newTasksAllowed_0,
  isProjectLocked21m24mmy2in1h as isProjectLocked,
  newNotesAllowed1s45uieazjo3d as newNotesAllowed,
  displayState3v4rl6ol8mfdu as displayState,
} from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { punchListCol2kgyh2t54dmzo as punchListCol } from '../punchList/renderPunchlists.mjs';
import { renderContractorNotes38zg0r7j0ume5 as renderContractorNotes } from '../../renderContractorNotes.mjs';
import {
  lineItemActions16vo8euhaqrwf as lineItemActions,
  lineItemBanners14ilhfznw9y75 as lineItemBanners,
} from './lineItemDetails.mjs';
import {
  get_darkSection25mxxvxk8ts3b as get_darkSection,
  LightSection_getInstance1p9fz392synu9 as LightSection_getInstance,
  get_lightSection4cpu8okr0w14 as get_lightSection,
} from '../../../../theming/sections.mjs';
import { mobileButtonRow232s2tjlco685 as mobileButtonRow } from '../../../../../utils/ButtonAction.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Data3qblafqxenieu as Data } from '../../../../screens/common/AuthorizedProjectView.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { get_scrolling27q1yr4ng0cx8 as get_scrolling } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic } from '../../../../theming/states.mjs';
import {
  escalationIconmtio0lqe8r8o as escalationIcon,
  timerRunningIcon3mra8cwh7awq2 as timerRunningIcon,
} from '../../../iconShortcuts.mjs';
import { InnerTabBar_getInstance20l55y0u7bopn as InnerTabBar_getInstance } from '../../../../theming/tabs.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  get_requiredMembershipRole1cjo4vwylx1kv as get_requiredMembershipRole,
  get_finishRegistrationMessage1yrf9ce4f09f0 as get_finishRegistrationMessage,
  get_awaitingApprovalMessage2f85iqlczrbum as get_awaitingApprovalMessage,
  renderFinishRegistrationc1cqjl7so0e8 as renderFinishRegistration,
  renderAwaitingApproval2nft16oqsuwts as renderAwaitingApproval,
  render2ibcvtmr1nr93 as render,
  MightBeContractorPage1c5hm6d3mwsqz as MightBeContractorPage,
} from '../../../../screens/contractor/IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.phu_1.f2();
}
function LineItemDetailsPage$WorkItemSection$Companion$_anonymous__51pvd4() {
  return createSimpleEnumSerializer('com.crowpay.views.components.project.work.scope.LineItemDetailsPage.WorkItemSection', values());
}
var WorkItemSection_Info_instance;
var WorkItemSection_Ledger_instance;
var WorkItemSection_Tasks_instance;
var WorkItemSection_Notes_instance;
function values() {
  return [WorkItemSection_Info_getInstance(), WorkItemSection_Ledger_getInstance(), WorkItemSection_Tasks_getInstance(), WorkItemSection_Notes_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.phu_1 = lazy(tmp_0, LineItemDetailsPage$WorkItemSection$Companion$_anonymous__51pvd4);
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_2;
function Companion_getInstance() {
  WorkItemSection_initEntries();
  if (Companion_instance_2 === VOID)
    new (Companion())();
  return Companion_instance_2;
}
var WorkItemSection_entriesInitialized;
function WorkItemSection_initEntries() {
  if (WorkItemSection_entriesInitialized)
    return Unit_instance;
  WorkItemSection_entriesInitialized = true;
  WorkItemSection_Info_instance = WorkItemSection().thu('Info', 0, 'Info');
  WorkItemSection_Ledger_instance = WorkItemSection().thu('Ledger', 1, 'Log');
  WorkItemSection_Tasks_instance = WorkItemSection().thu('Tasks', 2, 'Tasks');
  WorkItemSection_Notes_instance = WorkItemSection().thu('Notes', 3, 'Notes');
  Companion_getInstance();
}
var $ENTRIES;
function LineItemDetailsPage$WorkLogCard$default$lambda($this$to, disabled) {
  var tmp = HoverSemantic_getInstance();
  return disabled.td1('dsbl', VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf(to(tmp, LineItemDetailsPage$WorkLogCard$default$lambda$lambda))).cb1_1;
}
function LineItemDetailsPage$WorkLogCard$default$lambda$lambda($this$to, it) {
  return it.cb1_1;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = assertViewerLens($this.uhu_1, $this.uhu_1.af6_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.vhu_1.bf6_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp.s94();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x5a_1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var change = tmp_0;
  JumpTo_getInstance().pg3_1.bg5($this.vhu_1.zf5_1);
  get_mainPageNavigator($this.whu_1).fbw(new (ChangeOrderDetails())($this.vhu_1.yf5_1, change, $this.vhu_1.af6_1, $this.vhu_1));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.xhu_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var it = tmp;
  if (it instanceof Credit()) {
    JumpTo_getInstance().zg3_1.zg4(it, $this.yhu_1);
  } else {
    if (it instanceof ItemChange()) {
      JumpTo_getInstance().pg3_1.zg4(it.v6a_1, $this.yhu_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zhu_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  if (c instanceof Credit()) {
    var tmp_0;
    if (c.a5r_1 == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = $this.ahv_1.bf6_1;
      var tmp_1 = await_0(this_1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var line = tmp_1;
      var tmp_2 = Companion_instance_0;
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $this.ahv_1.lfy();
      var tmp_3 = await_0(this_2, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp$ret$2 = tmp_3;
      var tmp_4 = tmp_2.egu(line, tmp$ret$2, $this.ahv_1.af6_1, VOID, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp_0 = tmp_4;
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = c.b5r_1;
      var tmp_6;
      if (tmp2_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_3 = get_session();
        var tmp_7 = await_0(this_3, $completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
        var session = tmp_7;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_4 = session.ifw_1.mft(tmp2_safe_receiver);
        var tmp_8 = await_0(this_4, $completion);
        if (tmp_8 === get_COROUTINE_SUSPENDED())
          tmp_8 = yield tmp_8;
        var tmp0_elvis_lhs = tmp_8;
        var tmp_9;
        if (tmp0_elvis_lhs == null) {
          throw NotFound().pfx(getKClass(Incident()), null);
        } else {
          tmp_9 = tmp0_elvis_lhs;
        }
        var incident = tmp_9;
        var tmp_10 = Companion_instance_1;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_5 = $this.ahv_1.lfy();
        var tmp_11 = await_0(this_5, $completion);
        if (tmp_11 === get_COROUTINE_SUSPENDED())
          tmp_11 = yield tmp_11;
        var tmp_12 = tmp_11;
        // Inline function 'com.lightningkite.lightningdb.Query' call
        var limit = 2147483647;
        // Inline function 'kotlin.collections.listOf' call
        var orderBy = emptyList();
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_13 = serializerOrContextual(createKType(getKClass(IncidentMessage()), arrayOf([]), false));
        var tmp$ret$9 = isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$9);
        var tmp$ret$11 = eq(get_incident(it), tmp2_safe_receiver);
        var tmp$ret$12 = new (Query())(tmp$ret$11, orderBy, 0, limit);
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_6 = session.jfw_1.heo(tmp$ret$12);
        var tmp_14 = await_0(this_6, $completion);
        if (tmp_14 === get_COROUTINE_SUSPENDED())
          tmp_14 = yield tmp_14;
        // Inline function 'kotlin.collections.sortedBy' call
        var this_7 = tmp_14;
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_15 = LineItemDetailsPage$changeLog$lambda$slambda$lambda;
        var tmp$ret$14 = new (sam$kotlin_Comparator$0_0())(tmp_15);
        var tmp$ret$15 = sortedWith(this_7, tmp$ret$14);
        var tmp_16 = tmp_10.xgq(tmp_12, incident, tmp$ret$15, $this.ahv_1.af6_1, $completion);
        if (tmp_16 === get_COROUTINE_SUSPENDED())
          tmp_16 = yield tmp_16;
        tmp_6 = tmp_16;
      }
      tmp_5 = tmp_6;
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_5;
    var tmp_17;
    if (tmp3_elvis_lhs == null) {
      var tmp_18;
      if (c.c5r_1 == null) {
        tmp_18 = c;
      } else {
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_8 = $this.ahv_1.lfy();
        var tmp_19 = await_0(this_8, $completion);
        if (tmp_19 === get_COROUTINE_SUSPENDED())
          tmp_19 = yield tmp_19;
        // Inline function 'kotlin.collections.find' call
        var tmp0 = tmp_19.x7b_1;
        var tmp$ret$20;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.c5r_1 == c.c5r_1) {
              tmp$ret$20 = element;
              break $l$block;
            }
          }
          tmp$ret$20 = null;
        }
        tmp_18 = tmp$ret$20;
      }
      var tmp4_safe_receiver = tmp_18;
      var tmp_20;
      if (tmp4_safe_receiver == null) {
        tmp_20 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_9 = get_session();
        var tmp_21 = await_0(this_9, $completion);
        if (tmp_21 === get_COROUTINE_SUSPENDED())
          tmp_21 = yield tmp_21;
        var session_0 = tmp_21;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_10 = $this.ahv_1.lfy();
        var tmp_22 = await_0(this_10, $completion);
        if (tmp_22 === get_COROUTINE_SUSPENDED())
          tmp_22 = yield tmp_22;
        var project = tmp_22;
        var tmp0_safe_receiver = project.a7b_1;
        var tmp_23;
        if (tmp0_safe_receiver == null) {
          tmp_23 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_23 = session_0.kfv_1.geo(tmp0_safe_receiver);
        }
        var tmp1_safe_receiver = tmp_23;
        var tmp_24;
        if (tmp1_safe_receiver == null) {
          tmp_24 = null;
        } else {
          var tmp_25 = await_0(tmp1_safe_receiver, $completion);
          if (tmp_25 === get_COROUTINE_SUSPENDED())
            tmp_25 = yield tmp_25;
          tmp_24 = tmp_25;
        }
        var tmp2_elvis_lhs = tmp_24;
        var tmp_26;
        if (tmp2_elvis_lhs == null) {
          throw NotFound().pfx(getKClass(Client()), null);
        } else {
          tmp_26 = tmp2_elvis_lhs;
        }
        var tmp_27 = tmp_26;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_11 = session_0.lfv_1.geo(project.x7a_1);
        var tmp_28 = await_0(this_11, $completion);
        if (tmp_28 === get_COROUTINE_SUSPENDED())
          tmp_28 = yield tmp_28;
        var tmp3_elvis_lhs_0 = tmp_28;
        var tmp_29;
        if (tmp3_elvis_lhs_0 == null) {
          throw NotFound().pfx(getKClass(Contractor()), null);
        } else {
          tmp_29 = tmp3_elvis_lhs_0;
        }
        var tmp_30 = tmp_29;
        // Inline function 'com.lightningkite.reactive.context.invoke' call
        var this_12 = get_session();
        var tmp_31 = await_0(this_12, $completion);
        if (tmp_31 === get_COROUTINE_SUSPENDED())
          tmp_31 = yield tmp_31;
        var tmp_32 = tmp_31.gfv_1;
        var tmp_33;
        if (c.c5r_1 == null) {
          // Inline function 'com.lightningkite.reactive.context.invoke' call
          var this_13 = $this.ahv_1.bf6_1;
          var tmp_34 = await_0(this_13, $completion);
          if (tmp_34 === get_COROUTINE_SUSPENDED())
            tmp_34 = yield tmp_34;
          tmp_33 = tmp_34.jf9_1;
        } else {
          tmp_33 = null;
        }
        tmp_20 = new (CreditDetails())(tmp4_safe_receiver, tmp_27, tmp_30, tmp_32, project, tmp_33);
      }
      tmp_17 = tmp_20;
    } else {
      tmp_17 = tmp3_elvis_lhs;
    }
    var page = tmp_17;
    if (page == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      get_mainPageNavigator($this.bhv_1).fbw(page);
    }
  } else {
    if (c instanceof ItemChange()) {
      JumpTo_getInstance().pg3_1.bg5(c.v6a_1);
      get_mainPageNavigator($this.bhv_1).fbw(new (ChangeOrderDetails())($this.ahv_1.yf5_1, c.x6a_1, $this.ahv_1.af6_1, $this.ahv_1));
    } else {
      noWhenBranchMatchedException();
    }
  }
  return Unit_instance;
}
function LineItemDetailsPage$changeLog$lambda$slambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.c68_1;
  var tmp$ret$1 = b.c68_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_invoke__zhh2q8_3($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfv_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.dhv_1.df6_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = markAsReadUpdateOnRemove(tmp_0, $this.chv_1, tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var _receiver__tnumb7 = $this.ehv_1;
  var tmp = _receiver__tnumb7.f2();
  var tmp_0 = awaitOnce($this.fhv_1.lfy(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fhv_1.bf6_1;
  var tmp_1 = await_0(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$0 = tmp_1;
  _receiver__tnumb7.oam(plus(tmp, Signal().hak(new (PunchListItem())(VOID, tmp_0.v7a_1, tmp$ret$0.mf9_1, VOID, VOID, '', false))));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_5($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.bfw_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.hhv_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = markAsReadUpdateOnRemove(tmp_0, $this.ghv_1, tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ihv_1.bf6_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var it = tmp;
  get_dialogStack().zgd(CreateOrEditNote().ih0(it.lfy(), it.mf9_1, null));
  return Unit_instance;
}
var WorkItemSectionClass;
function WorkItemSection() {
  if (WorkItemSectionClass === VOID) {
    class $ extends Enum() {
      static thu(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.shu_1 = displayName;
        return $this;
      }
      e90() {
        return this.shu_1;
      }
    }
    protoOf($).d90 = get_shortDisplayName;
    initMetadataForClass($, 'WorkItemSection', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance});
    WorkItemSectionClass = $;
  }
  return WorkItemSectionClass;
}
function infoSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  labeledSection(view, 'Description', ($this$labeledSection) => {
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$labeledSection.pc());
    var tmp0_elvis_lhs = $this$labeledSection.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
    $this$labeledSection.gbb(p, view);
    view.lba(view.qb6_1.abf(BodySemantic_getInstance()));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl_1(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj($this.bf6_1).pf9_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    $this$labeledSection.hbb(p, view);
    return Unit_instance;
  });
  _this__u8e3s4.hbb(p, view);
  return view;
}
function ledgerSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().bg2_1);
  if ($this.af6_1.equals(ProjectLens_Contractor_getInstance())) {
    var tmp = get_atTopEnd(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    var item = lens($this.bf6_1, LineItemDetailsPage$ledgerSection$lambda);
    lineItemAddChangeButton($this, view_0, item);
    lineItemAddCreditButton(view_0, item, $this.lfy());
    view.hbb(p_0, view_0);
    view.lbb(tmp, view_0);
  }
  labeledSection(view, 'Ledger', ($this$labeledSection) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$labeledSection.pc());
    var tmp0_elvis_lhs = $this$labeledSection.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$labeledSection : tmp0_elvis_lhs;
    $this$labeledSection.gbb(p, view);
    view.zbm(true);
    keyMoney(view, 'Original Price', ($this$keyMoney) => new (MonetaryValue())($this$keyMoney.daj($this.bf6_1).jf9_1.l6k_1));
    // Inline function 'com.crowpay.views.components.keyView' call
    var key = 'Accepted Changes';
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    view_0.bb9(get_rem(0.5));
    bodyBold(view_0, key + ':');
    var tmp = get_expanding(view_0);
    var tmp$ret$6 = renderPriceChange(view_0, false, ($this$renderPriceChange) => {
      // Inline function 'kotlin.let' call
      var it = $this$renderPriceChange.daj($this.bf6_1).jf9_1;
      var tmp$ret$5 = MonetaryValue__minus_impl_jw9qyp(it.d6l_1, it.l6k_1);
      return new (MonetaryValue())(tmp$ret$5);
    });
    view_0.lbb(tmp, tmp$ret$6);
    view.hbb(p_0, view_0);
    // Inline function 'com.crowpay.views.components.keyView' call
    var key_0 = 'Active Price';
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    view_1.zbm(false);
    view_1.bb9(get_rem(0.5));
    bodyBold(view_1, key_0 + ':');
    var tmp_0 = get_expanding(view_1);
    var tmp_1 = ($this$priceWithChange) => new (MonetaryValue())($this$priceWithChange.daj($this.bf6_1).jf9_1.d6l_1);
    var tmp$ret$14 = priceWithChange(view_1, false, tmp_1, ($this$priceWithChange) => {
      // Inline function 'kotlin.let' call
      var it = $this$priceWithChange.daj($this.bf6_1).jf9_1;
      var tmp$ret$13 = MonetaryValue__minus_impl_jw9qyp(it.d6l_1, it.l6k_1);
      return new (MonetaryValue())(tmp$ret$13);
    });
    view_1.lbb(tmp_0, tmp$ret$14);
    view.hbb(p_1, view_1);
    keyMoney(view, 'Paid', ($this$keyMoney) => $this$keyMoney.daj($this.kf6_1));
    keyString(view, '% Complete', ($this$keyString) => {
      var price = $this$keyString.daj($this.bf6_1).jf9_1.d6l_1;
      return renderPercent(percentComplete($this$keyString.daj($this.kf6_1).y5r_1, price));
    });
    $this$labeledSection.hbb(p, view);
    return Unit_instance;
  });
  view.lbb(shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this$shownWhen.daj($this.mf6_1).i1()) {
      tmp = true;
    } else {
      tmp = !($this$shownWhen.daj($this.bf6_1).s94() == null);
    }
    return tmp;
  }), changeLog($this, view));
  _this__u8e3s4.hbb(p, view);
  return view;
}
function changeLog($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_dp(5));
  bodyBold(view, 'Changes');
  var tmp = view.jbb(WorkLogCard_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_dp(5));
  var tmp_0 = get_centered(view_1);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  var tmp_1 = KMutableProperty0();
  var tmp_2 = TextView$_get_content_$ref_4pzcwl_2(view_2);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_2(view_2));
  reactiveScope(view_2, ($this$reactiveScope) => {
    var tmp$ret$0 = !($this$reactiveScope.daj($this.bf6_1).s94() == null) ? 'New' : 'Original';
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_0, view_2);
  var tmp_3 = view_1.kbb(view_1.kbb(get_expanding(view_1), get_centered(view_1)), get_italic(view_1));
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_3 = view_1.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
  view_1.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_3(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_3(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj($this.bf6_1).s94();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y5a_1;
    var tmp$ret$7 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_1.set(tmp$ret$7);
    return Unit_instance;
  });
  view_1.hbb(p_3, view_3);
  view_1.lbb(tmp_3, view_3);
  var tmp_6 = get_centered(view_1);
  var tmp_7 = ($this$priceWithChange) => new (MonetaryValue())($this$priceWithChange.daj($this.bf6_1).jf9_1.l6k_1);
  view_1.lbb(tmp_6, priceWithChange(view_1, false, tmp_7, ($this$priceWithChange) => {
    // Inline function 'kotlin.let' call
    var line = $this$priceWithChange.daj($this.bf6_1);
    // Inline function 'kotlin.takeIf' call
    var this_0 = new (MonetaryValue())(line.jf9_1.l6k_1);
    var tmp;
    this_0.y5r_1;
    if (!(line.s94() == null)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp_0 = tmp;
    var tmp_1 = tmp_0 == null ? null : tmp_0.y5r_1;
    var tmp_2 = tmp_1 == null ? null : new (MonetaryValue())(tmp_1);
    var tmp_3 = tmp_2 == null ? null : tmp_2.y5r_1;
    return tmp_3 == null ? null : new (MonetaryValue())(tmp_3);
  }));
  view_0.hbb(p_1, view_1);
  var tmp_8 = KMutableProperty0();
  var tmp_9 = Button$_get_enabled_$ref_61t7nx(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('enabled', 0, tmp_8, tmp_9, Button$_set_enabled_$ref_o8kynz(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$22 = !($this$reactiveScope.daj($this.bf6_1).s94() == null);
    this_2.set(tmp$ret$22);
    return Unit_instance;
  });
  onClick(view_0, VOID, VOID, LineItemDetailsPage$changeLog$slambda_0($this, view_0));
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_10 = view.jbb(ListSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.zbm(true);
  forEachUpdating(view_4, $this.mf6_1, VOID, ($this$forEachUpdating, item) => {
    var tmp = $this$forEachUpdating.jbb(WorkLogCard_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (Button())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.gbb(p, view);
    launch(view, VOID, VOID, LineItemDetailsPage$changeLog$lambda$slambda_0(item, view));
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    view_0.bb9(get_dp(5));
    var tmp_0 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_4(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_4(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$27 = $this$reactiveScope.daj(item).h94();
      this_0.set(tmp$ret$27);
      return Unit_instance;
    });
    view_0.hbb(p_1, view_1);
    view_0.lbb(tmp_0, view_1);
    var tmp_3 = view_0.kbb(view_0.kbb(get_expanding(view_0), get_centered(view_0)), get_italic(view_0));
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.gbb(p_2, view_2);
    view_2.lba(view_2.qb6_1.abf(SmallBodySemantic_getInstance()));
    var tmp_4 = KMutableProperty0();
    var tmp_5 = TextView$_get_content_$ref_4pzcwl_5(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_5(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp0_elvis_lhs = $this$reactiveScope.daj(item).e26();
      var tmp$ret$34 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      this_1.set(tmp$ret$34);
      return Unit_instance;
    });
    view_0.hbb(p_2, view_2);
    view_0.lbb(tmp_3, view_2);
    var tmp_6 = get_centered(view_0);
    view_0.lbb(tmp_6, renderPriceChange(view_0, false, ($this$renderPriceChange) => new (MonetaryValue())($this$renderPriceChange.daj(item).c95())));
    view.hbb(p_0, view_0);
    var tmp_7 = KMutableProperty0();
    var tmp_8 = Button$_get_enabled_$ref_61t7nx_0(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz_0(view));
    reactiveScope(view, ($this$reactiveScope) => {
      var it = $this$reactiveScope.daj(item);
      var tmp;
      if (it instanceof Credit()) {
        tmp = !(it.a5r_1 == null) || !(it.b5r_1 == null) || !(it.c5r_1 == null);
      } else {
        if (it instanceof ItemChange()) {
          tmp = true;
        } else {
          noWhenBranchMatchedException();
        }
      }
      var tmp$ret$45 = tmp;
      this_2.set(tmp$ret$45);
      return Unit_instance;
    });
    onClick(view, VOID, VOID, LineItemDetailsPage$changeLog$lambda$slambda_2(item, $this, view));
    $this$forEachUpdating.hbb(p, view);
    $this$forEachUpdating.lbb(tmp, view);
    return Unit_instance;
  });
  view.hbb(p_4, view_4);
  view.lbb(tmp_10, view_4);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function tasksSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var newItems = Signal().hak(emptyList());
  launch(view, VOID, VOID, LineItemDetailsPage$tasksSection$slambda_0(view, $this));
  var tmp = view.kbb(get_atEnd(view), get_tertiaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.gba(get_rem(0.3));
  view_0.bb9(get_rem(0.3));
  shownDefaultFalse(view_0, ($this$shownDefaultFalse) => $this.af6_1.equals(ProjectLens_Contractor_getInstance()) && newTasksAllowed($this$shownDefaultFalse.daj($this.lfy()).u7b_1) && newTasksAllowed_0($this$shownDefaultFalse.daj($this.bf6_1).mfy()));
  var tmp_0 = KMutableProperty0();
  var tmp_1 = Button$_get_enabled_$ref_61t7nx_1(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz_1(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = !isProjectLocked($this$reactiveScope.daj($this.lfy()).u7b_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  specCenteredText(view_0, '+ Work Task');
  onClick(view_0, VOID, VOID, LineItemDetailsPage$tasksSection$slambda_2(newItems, $this));
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  punchListCol(view, $this.df6_1, newItems, $this.bf6_1, $this.af6_1, true, true, '+ Work Task', Signal().hak(true));
  _this__u8e3s4.hbb(p, view);
  return view;
}
function notesSection($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var tmp = $this.zgz();
  var notes = filter(tmp, ($this$filter, it) => equals(it.d5p_1, $this.zf5_1));
  launch(view, VOID, VOID, LineItemDetailsPage$notesSection$slambda_0(view, notes));
  if ($this.af6_1.equals(ProjectLens_Contractor_getInstance())) {
    var tmp_0 = view.kbb(get_atEnd(view), get_tertiaryButton(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Button())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    var tmp_1 = KMutableProperty0();
    var tmp_2 = Button$_get_shown_$ref_hkylj1(view_0);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp_1, tmp_2, Button$_set_shown_$ref_bpvuvj(view_0));
    reactiveScope(view_0, ($this$reactiveScope) => {
      var tmp$ret$0 = !$this$reactiveScope.daj($this.bf6_1).qf9_1;
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    var tmp_3 = KMutableProperty0();
    var tmp_4 = Button$_get_enabled_$ref_61t7nx_2(view_0);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz_2(view_0));
    reactiveScope(view_0, ($this$reactiveScope) => {
      var tmp$ret$2 = newNotesAllowed($this$reactiveScope.daj($this.bf6_1).mfy());
      this_1.set(tmp$ret$2);
      return Unit_instance;
    });
    view_0.fba(get_rem(0.3));
    specCenteredText(view_0, '+ Work Note');
    onClick(view_0, VOID, VOID, LineItemDetailsPage$notesSection$slambda_2($this));
    view.hbb(p_0, view_0);
    view.lbb(tmp_0, view_0);
  }
  renderContractorNotes(view, notes, ($this$renderContractorNotes) => $this$renderContractorNotes.daj($this.bf6_1).nf9_1, $this.af6_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function actionBar($this, _this__u8e3s4) {
  var actions = lineItemActions(_this__u8e3s4, $this.bf6_1, $this.df6_1, $this.lfy(), $this.ef6_1, $this.gf6_1, $this.jf6_1, $this.hf6_1, $this.uh2(), $this.af6_1);
  return _this__u8e3s4.lbb(_this__u8e3s4.kbb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.daj($this.bf6_1).g99() == null), get_darkSection(_this__u8e3s4)), mobileButtonRow(_this__u8e3s4, reversed(toList(actions))));
}
var WorkLogCardClass;
function WorkLogCard() {
  if (WorkLogCardClass === VOID) {
    class $ extends Semantic() {
      static khv() {
        WorkLogCard_instance = null;
        var $this = this.dd1('wrkcrd');
        WorkLogCard_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp = theme.fb1(LightSection_getInstance()).gb1_1;
        var tmp_0 = DisabledSemantic_getInstance();
        return this.jd1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf(to(tmp_0, LineItemDetailsPage$WorkLogCard$default$lambda)));
      }
      toString() {
        return 'WorkLogCard';
      }
      hashCode() {
        return 328896043;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WorkLogCard()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'WorkLogCard');
    WorkLogCardClass = $;
  }
  return WorkLogCardClass;
}
var WorkLogCard_instance;
function WorkLogCard_getInstance() {
  if (WorkLogCard_instance === VOID)
    WorkLogCard().khv();
  return WorkLogCard_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.lhv_1 = function_0;
      }
      wi(a, b) {
        return this.lhv_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.lhv_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.mhv_1 = function_0;
      }
      wi(a, b) {
        return this.mhv_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.mhv_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function LineItemDetailsPage$myRole$lambda($this$remember) {
  var tmp0_safe_receiver = $this$remember.daj($this$remember.daj(get_session()).rfw_1).k88_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h8c_1;
}
var LineItemDetailsPage$renderMainContent$slambdaClass;
function LineItemDetailsPage$renderMainContent$slambda() {
  if (LineItemDetailsPage$renderMainContent$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.uhu_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemDetailsPage$renderMainContent$slambdaClass = $;
  }
  return LineItemDetailsPage$renderMainContent$slambdaClass;
}
function LineItemDetailsPage$renderMainContent$slambda_0(this$0) {
  var i = new (LineItemDetailsPage$renderMainContent$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function LineItemDetailsPage$changes$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.d95();
  var tmp$ret$1 = b.d95();
  return compareValues(tmp, tmp$ret$1);
}
function LineItemDetailsPage$ledgerSection$lambda(it) {
  return it.jf9_1;
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LineItemDetailsPage$changeLog$slambdaClass;
function LineItemDetailsPage$changeLog$slambda() {
  if (LineItemDetailsPage$changeLog$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.vhu_1 = this$0;
        this.whu_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemDetailsPage$changeLog$slambdaClass = $;
  }
  return LineItemDetailsPage$changeLog$slambdaClass;
}
function LineItemDetailsPage$changeLog$slambda_0(this$0, $$this$button) {
  var i = new (LineItemDetailsPage$changeLog$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LineItemDetailsPage$changeLog$lambda$slambdaClass;
function LineItemDetailsPage$changeLog$lambda$slambda() {
  if (LineItemDetailsPage$changeLog$lambda$slambdaClass === VOID) {
    class $ {
      constructor($item, $$this$button) {
        this.xhu_1 = $item;
        this.yhu_1 = $$this$button;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemDetailsPage$changeLog$lambda$slambdaClass = $;
  }
  return LineItemDetailsPage$changeLog$lambda$slambdaClass;
}
function LineItemDetailsPage$changeLog$lambda$slambda_0($item, $$this$button) {
  var i = new (LineItemDetailsPage$changeLog$lambda$slambda())($item, $$this$button);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LineItemDetailsPage$changeLog$lambda$slambdaClass_0;
function LineItemDetailsPage$changeLog$lambda$slambda_1() {
  if (LineItemDetailsPage$changeLog$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($item, this$0, $$this$button) {
        this.zhu_1 = $item;
        this.ahv_1 = this$0;
        this.bhv_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemDetailsPage$changeLog$lambda$slambdaClass_0 = $;
  }
  return LineItemDetailsPage$changeLog$lambda$slambdaClass_0;
}
function LineItemDetailsPage$changeLog$lambda$slambda_2($item, this$0, $$this$button) {
  var i = new (LineItemDetailsPage$changeLog$lambda$slambda_1())($item, this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LineItemDetailsPage$tasksSection$slambdaClass;
function LineItemDetailsPage$tasksSection$slambda() {
  if (LineItemDetailsPage$tasksSection$slambdaClass === VOID) {
    class $ {
      constructor($$this$col, this$0) {
        this.chv_1 = $$this$col;
        this.dhv_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemDetailsPage$tasksSection$slambdaClass = $;
  }
  return LineItemDetailsPage$tasksSection$slambdaClass;
}
function LineItemDetailsPage$tasksSection$slambda_0($$this$col, this$0) {
  var i = new (LineItemDetailsPage$tasksSection$slambda())($$this$col, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LineItemDetailsPage$tasksSection$slambdaClass_0;
function LineItemDetailsPage$tasksSection$slambda_1() {
  if (LineItemDetailsPage$tasksSection$slambdaClass_0 === VOID) {
    class $ {
      constructor($newItems, this$0) {
        this.ehv_1 = $newItems;
        this.fhv_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemDetailsPage$tasksSection$slambdaClass_0 = $;
  }
  return LineItemDetailsPage$tasksSection$slambdaClass_0;
}
function LineItemDetailsPage$tasksSection$slambda_2($newItems, this$0) {
  var i = new (LineItemDetailsPage$tasksSection$slambda_1())($newItems, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var LineItemDetailsPage$notesSection$slambdaClass;
function LineItemDetailsPage$notesSection$slambda() {
  if (LineItemDetailsPage$notesSection$slambdaClass === VOID) {
    class $ {
      constructor($$this$col, $notes) {
        this.ghv_1 = $$this$col;
        this.hhv_1 = $notes;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemDetailsPage$notesSection$slambdaClass = $;
  }
  return LineItemDetailsPage$notesSection$slambdaClass;
}
function LineItemDetailsPage$notesSection$slambda_0($$this$col, $notes) {
  var i = new (LineItemDetailsPage$notesSection$slambda())($$this$col, $notes);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.yb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function Button$_get_enabled_$ref_61t7nx_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.vb5_1.bb4_1.kb7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.vb5_1.bb4_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.kb7_1.disabled = value;
    return Unit_instance;
  };
}
var LineItemDetailsPage$notesSection$slambdaClass_0;
function LineItemDetailsPage$notesSection$slambda_1() {
  if (LineItemDetailsPage$notesSection$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.ihv_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemDetailsPage$notesSection$slambdaClass_0 = $;
  }
  return LineItemDetailsPage$notesSection$slambdaClass_0;
}
function LineItemDetailsPage$notesSection$slambda_2(this$0) {
  var i = new (LineItemDetailsPage$notesSection$slambda_1())(this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function WorkItemSection_Info_getInstance() {
  WorkItemSection_initEntries();
  return WorkItemSection_Info_instance;
}
function WorkItemSection_Ledger_getInstance() {
  WorkItemSection_initEntries();
  return WorkItemSection_Ledger_instance;
}
function WorkItemSection_Tasks_getInstance() {
  WorkItemSection_initEntries();
  return WorkItemSection_Tasks_instance;
}
function WorkItemSection_Notes_getInstance() {
  WorkItemSection_initEntries();
  return WorkItemSection_Notes_instance;
}
var LineItemDetailsPageClass;
function LineItemDetailsPage() {
  if (LineItemDetailsPageClass === VOID) {
    class $ {
      constructor(projectId, lineItemId, lens_0, parent) {
        parent = parent === VOID ? null : parent;
        var tmp = this;
        tmp.xf5_1 = parent == null ? new (Data())(lens_0, projectId) : parent;
        this.yf5_1 = projectId;
        this.zf5_1 = lineItemId;
        this.af6_1 = lens_0;
        var tmp_0 = this;
        tmp_0.bf6_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this$remember.daj(this.vgm());
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.mf9_1.equals(this.zf5_1)) {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw NotFound().pfx(getKClass(LineItem()), null);
          } else {
            tmp = tmp0_elvis_lhs;
          }
          return tmp;
        });
        var tmp_1 = this;
        tmp_1.cf6_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.bf6_1).nf9_1);
        var tmp_2 = this;
        var tmp_3 = this.wgm();
        tmp_2.df6_1 = lens(tmp_3, (it) => {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = it.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (equals(element.l7w_1, this.zf5_1)) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_4 = this;
        var tmp_5 = this.dgt();
        tmp_4.ef6_1 = lens(tmp_5, (it) => {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = it.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.y6g_1.equals(this.zf5_1)) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_6 = this;
        var tmp_7 = this.jgt();
        tmp_6.ff6_1 = lens(tmp_7, (it) => {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = it.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.q6v_1.equals(this.zf5_1)) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_8 = this;
        tmp_8.gf6_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.daj(this.ff6_1);
          var tmp$ret$12;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$12 = false;
              break $l$block_1;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (element.z6v_1) {
                tmp$ret$12 = true;
                break $l$block_1;
              }
            }
            tmp$ret$12 = false;
          }
          return tmp$ret$12;
        });
        var tmp_9 = this;
        tmp_9.hf6_1 = remember(VOID, VOID, VOID, LineItemDetailsPage$myRole$lambda);
        var tmp_10 = this;
        tmp_10.if6_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.xgv());
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!(element.t57_1 == null)) {
              destination.v(element);
            }
          }
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var item = _iterator__ex2g4s_0.o1();
            var tmp$ret$17 = item.o57_1;
            destination_0.v(tmp$ret$17);
          }
          return destination_0;
        });
        var tmp_11 = this;
        tmp_11.jf6_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var published = $this$remember.daj(this.if6_1);
          var tmp0 = $this$remember.daj(this.kgt());
          var tmp$ret$20;
          $l$block_3: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$20 = false;
              break $l$block_3;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (get_pending(element) && element.d72_1.equals(this.zf5_1) && published.t1(element.c72_1)) {
                tmp$ret$20 = true;
                break $l$block_3;
              }
            }
            tmp$ret$20 = false;
          }
          return tmp$ret$20;
        });
        var tmp_12 = this;
        tmp_12.kf6_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var line = $this$remember.daj(this.bf6_1);
          var tmp;
          if (!(line.ofy() == null)) {
            return new (MonetaryValue())(line.jf9_1.d6l_1);
          }
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.daj(this.ff6_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.z6v_1 || element.x6v_1 === true) {
              destination.v(element);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.r91(0n);
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp_0 = sum;
            var tmp$ret$25 = element_0.r6v_1;
            sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$25);
          }
          var tmp$ret$26 = sum;
          return new (MonetaryValue())(tmp$ret$26);
        });
        this.lf6_1 = Signal().hak(WorkItemSection_Info_getInstance());
        var tmp_13 = this;
        tmp_13.mf6_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.let' call
          var it = $this$remember.daj(this.bf6_1);
          // Inline function 'kotlin.collections.sortedBy' call
          var this_0 = plus_0(it.lf9_1, it.jf9_1.v6k_1);
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp = LineItemDetailsPage$changes$lambda$lambda;
          var tmp$ret$29 = new (sam$kotlin_Comparator$0())(tmp);
          return sortedWith(this_0, tmp$ret$29);
        });
      }
      lf8() {
        return this.yf5_1;
      }
      tgj() {
        return this.af6_1;
      }
      wcv() {
        return this.cf6_1;
      }
      uhf(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        launch(view, VOID, VOID, LineItemDetailsPage$renderMainContent$slambda_0(this));
        var tmp = view.kbb(get_expanding(view), get_scrolling(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        view_0.bb9(get_AppDimensions().bg2_1);
        var tmp_0 = get_lightSection(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zbm(true);
        title(view_1, ($this$title) => {
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_content_$ref_4pzcwl($this$title);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb($this$title));
          reactiveScope($this$title, ($this$reactiveScope) => {
            var tmp$ret$0 = $this$reactiveScope.daj(this.bf6_1).nf9_1;
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          return Unit_instance;
        });
        label2(view_1, 'Status', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.gbb(p, view);
          view.zbm(false);
          var tmp = get_centered(view);
          view.lbb(tmp, title(view, ($this$title) => {
            dynamicTheme($this$title, ($this$dynamicTheme) => LineItemStateSemantic(displayState($this$dynamicTheme.daj(this.bf6_1).mfy())));
            var tmp = KMutableProperty0();
            var tmp_0 = TextView$_get_content_$ref_4pzcwl_0($this$title);
            // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
            var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0($this$title));
            reactiveScope($this$title, ($this$reactiveScope) => {
              var tmp$ret$2 = displayState($this$reactiveScope.daj(this.bf6_1).mfy()).l9b_1;
              this_0.set(tmp$ret$2);
              return Unit_instance;
            });
            return Unit_instance;
          }));
          var tmp_0 = get_compact(view);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          view_0.zbm(false);
          var tmp_1 = get_centered(view_0);
          view_0.lbb(tmp_1, escalationIcon(view_0, remember(VOID, VOID, VOID, ($this$remember) => {
            var tmp0_safe_receiver = $this$remember.daj(this.ogf()).p3(this.zf5_1);
            return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l8w();
          })));
          view_0.lbb(get_centered(view_0), timerRunningIcon(this, view_0, this.bf6_1));
          view.hbb(p_0, view_0);
          view.lbb(tmp_0, view_0);
          $this$label2.hbb(p, view);
          return view;
        });
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_0, view_1);
        lineItemBanners(this, view_0, this.bf6_1, this.lfy(), this.ef6_1, this.gf6_1, this.jf6_1, this.af6_1, null);
        var tmp_1 = view_0.jbb(InnerTabBar_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.gbb(p_2, view_2);
        view_2.zbm(false);
        var _iterator__ex2g4s = get_entries().m1();
        while (_iterator__ex2g4s.n1()) {
          var section = _iterator__ex2g4s.o1();
          var tmp_2 = get_expanding(view_2);
          // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (ToggleButton())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.ebb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.gbb(p_3, view_3);
          view_3.lbb(get_centered(view_3), body(view_3, section.shu_1));
          view_3.zah(view_3.pcq_1, equalTo(this.lf6_1, section));
          view_2.hbb(p_3, view_3);
          view_2.lbb(tmp_2, view_3);
        }
        view_0.hbb(p_2, view_2);
        view_0.lbb(tmp_1, view_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (Frame())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.gbb(p_4, view_4);
        var $this$frame = view_4;
        reactive($this$frame, ($this$reactive) => {
          $this$frame.bba();
          var tmp;
          switch ($this$reactive.daj(this.lf6_1).b4_1) {
            case 0:
              tmp = infoSection(this, $this$frame);
              break;
            case 1:
              tmp = ledgerSection(this, $this$frame);
              break;
            case 2:
              tmp = tasksSection(this, $this$frame);
              break;
            case 3:
              tmp = notesSection(this, $this$frame);
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          return tmp;
        });
        view_0.hbb(p_4, view_4);
        view.hbb(p_0, view_0);
        view.lbb(tmp, view_0);
        actionBar(this, view);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
      lfy() {
        return this.xf5_1.lfy();
      }
      vgm() {
        return this.xf5_1.vgm();
      }
      zgz() {
        return this.xf5_1.zgz();
      }
      ygk() {
        return this.xf5_1.ygk();
      }
      hgl() {
        return this.xf5_1.hgl();
      }
      wgm() {
        return this.xf5_1.wgm();
      }
      xgv() {
        return this.xf5_1.xgv();
      }
      ngy() {
        return this.xf5_1.ngy();
      }
      kgt() {
        return this.xf5_1.kgt();
      }
      lgt() {
        return this.xf5_1.lgt();
      }
      jgt() {
        return this.xf5_1.jgt();
      }
      dgt() {
        return this.xf5_1.dgt();
      }
      ggt() {
        return this.xf5_1.ggt();
      }
      pgf() {
        return this.xf5_1.pgf();
      }
      qh2() {
        return this.xf5_1.qh2();
      }
      ogf() {
        return this.xf5_1.ogf();
      }
      uh2() {
        return this.xf5_1.uh2();
      }
    }
    protoOf($).dhg = get_requiredMembershipRole;
    protoOf($).ehg = get_finishRegistrationMessage;
    protoOf($).fhg = get_awaitingApprovalMessage;
    protoOf($).ghg = renderFinishRegistration;
    protoOf($).hhg = renderAwaitingApproval;
    protoOf($).wd6 = render;
    initMetadataForClass($, 'LineItemDetailsPage', VOID, VOID, [MightBeContractorPage()]);
    LineItemDetailsPageClass = $;
  }
  return LineItemDetailsPageClass;
}
//region block: exports
export {
  LineItemDetailsPage as LineItemDetailsPage1m0bbf89e2gid,
};
//endregion

//# sourceMappingURL=LineItemDetailsPage.mjs.map
